import "./App.css";
import Home from "./pages/Home";
import AboutMijsc from "./pages/About/aboutMijsc";
import Header from "./components/header/header";
import Footer from "./components/Footer/Footer";
import AboutLmp from "./pages/About/aboutLmp";
import KeyPeople from "./pages/About/keyPeople";
import Background from "./pages/About/background";
import { Routes, Route } from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
import Gallery from "./pages/Gallery/gallery";
import ContactUS from "./pages/Contact";
import MijscPrograms from "./pages/NewsAndEvents/Mijscprograms";
import UpcomingEvents from "./pages/NewsAndEvents/UpcomingEvents";
import LmpProgramsCoordinators from "./pages/NewsAndEvents/LmpProgramsCoordinators";
import IndustryExperts from "./pages/ProgramInformation/IndustryExperts";
import HybridLearningPlatforms from "./pages/ProgramInformation/HybridLearningPlatforms";
import ParticipatingColleges from "./pages/ProgramInformation/ParticipatingColleges";
import Academia from "./pages/Partners/Academia";
import Industry from "./pages/Partners/Industry";
import FacultyDevelopmentProgram from "./pages/NewsAndEvents/AbouMijsc/FacultyDevelopmentProgram";
import ConsultancyProgram from "./pages/NewsAndEvents/AbouMijsc/ConsultancyProgram";
import JlccProgram from "./pages/NewsAndEvents/AbouMijsc/JlccProgram";
import SkillDevelopment from "./pages/NewsAndEvents/AbouMijsc/SkillDevelopment";

function App() {
  return (
    <div className="App overflow-x-hidden">
      <ScrollToTop />
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about-mijsc" element={<AboutMijsc />} />
        <Route path="/about-lmp" element={<AboutLmp />} />
        <Route path="/key-people" element={<KeyPeople />} />
        <Route path="/background" element={<Background />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/contact-us" element={<ContactUS />} />
        <Route path="/mijsc-programs" element={<MijscPrograms />} />
        <Route path="/upcoming-events" element={<UpcomingEvents />} />
        <Route
          path="/program-coordinators"
          element={<LmpProgramsCoordinators />}
        />
        <Route
          path="/hybrid-learning-platforms"
          element={<HybridLearningPlatforms />}
        />
        <Route path="/industry-experts" element={<IndustryExperts />} />
        <Route path="/batches" element={<ParticipatingColleges />} />
        <Route path="/academia" element={<Academia />} />
        <Route path="/industry" element={<Industry />} />
        <Route
          path="/faculty-development-program"
          element={<FacultyDevelopmentProgram />}
        />
        <Route path="/consultancy-program" element={<ConsultancyProgram />} />
        <Route path="/jlcc-program" element={<JlccProgram />} />
        <Route path="/skill-development" element={<SkillDevelopment />} />
      </Routes>
      <Footer />
    </div>
  );
}

export default App;
